import { useMemo } from 'react';
import type { QueryParameterConfig } from './useQueryParameter';

export const useWithDefault = <T, K = T>(
  config: QueryParameterConfig<T, undefined>,
  defaultValue: K,
): QueryParameterConfig<T, K> =>
  useMemo(
    () => ({
      decode(value) {
        return config.decode(value) ?? defaultValue;
      },
      default: defaultValue,
      encode: config.encode,
    }),
    [config, defaultValue],
  );
